import { render, staticRenderFns } from "./JoyWindow.vue?vue&type=template&id=a4a73d8a&"
import script from "./JoyWindow.vue?vue&type=script&lang=js&"
export * from "./JoyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports